import PromptConfigView from "./PromptConfigView";

export default PromptConfigView;